import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { loadingServiceSlice } from "../StateManagement/loadingServiceSlice";

export const useLoad = (name, pageLoad) => {
  const dispatch = useDispatch();

  const load = useCallback(() => {
    dispatch(loadingServiceSlice.actions.load({ name, pageLoad }));
  }, [dispatch, name, pageLoad]);

  const unload = useCallback(() => {
    dispatch(loadingServiceSlice.actions.unload({ name, pageLoad }));
  }, [dispatch, name, pageLoad]);

  return { load, unload };
};
